<template>
  <v-flex xs12>
    <v-card>
      <v-toolbar color="primary" dark class="pb-0 mb-0">
        <v-btn icon @click="goBack">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('Conversaciones') }} || Asunto: {{ thread.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat v-if="thread.read_by_customer === 1" @click="readLater(true)">
          {{ $t('Marcar como NO leida') }}
        </v-btn>
      </v-toolbar>
      <v-progress-linear
        v-if="loading"
        class="py-0 my-0"
        height="3"
        :indeterminate="loading"
      ></v-progress-linear>
      <div class="scroll-y" id="conversation-container" style="max-height: 60vh">
        <v-container class="grey lighten-4 ma-0">
          <template v-if="!loading">
            <template v-for="message in thread.messages">
              <v-layout
                align-center
                :justify-start="thread.consultants.includes(message.user_id)"
                :justify-end="message.user_id === thread.user_id"
                row
                fill-height
                wrap
                :key="message.id"
                px-2
              >
                <v-flex xs11>
                  <v-card
                    class="mt-3"
                    :class="{ 'consultant-message': thread.consultants.includes(message.user_id) }"
                  >
                    <v-card-text contain>
                      <user-avatar :size="40" :user="message.user">
                        <span class="mr-3">
                          {{ message.created_at | moment('from', 'now') }}
                        </span>
                        <span class="mr-3">
                          {{ message.created_at | moment('DD/MM/YYYY') }}
                        </span>
                      </user-avatar>
                    </v-card-text>
                    <v-card-text>
                      <v-icon
                        color="primary"
                        v-if="message.attached"
                        @click="downloadEntity(message.attached)"
                      >
                        mdi-download
                      </v-icon>

                      <span v-html="message.message" class="message-container"></span>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
            <div id="conversation-end"></div>
          </template>
        </v-container>
      </div>
      <message-form :thread="thread" @created="newMessage"></message-form>
    </v-card>
  </v-flex>
</template>

<script>
import ThreadAPI from '../../services/thread.js';
import UserAvatar from '@/components/commons//UserAvatar.vue';
import MessageForm from './MessageForm.vue';
// import vue2Dropzone from 'vue2-dropzone';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

// import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    UserAvatar,
    MessageForm,
    // vueDropzone: vue2Dropzone
  },
  data() {
    return {
      page: 1,
      thread: {},
      loading: true,
      scrollTarget: '#conversation-end',
      scrollOptions: {
        duration: 500,
        offset: 0,
        easing: 'easeInOutCubic',
        container: '#conversation-container',
      },
      // dropZoneOptions: {
      //     url: '',
      //     thumbnailWidth: 100,
      //     maxFilesize: 5,
      //     clickable: '#attach-file-button',

      //     params: {
      //         thread_id: '',
      //         message: ''
      //     }
      // }
    };
  },
  created() {
    // this.getThread();
  },
  async mounted() {
    await this.getThread();
    this.markAsRead();
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/myconsultant',
      });
    },
    async getThread() {
      this.loading = true;
      console.log({
        routeparams: this.$route.params,
      });
      await ThreadAPI.getThread(this.$route.params.thread).then(response => {
        this.thread = response.data.data;

        // this.dropZoneOptions.url = ThreadAPI.threadPostMessageUrl(this.thread.id);
        this.loading = false;
        const component = this;
        setTimeout(function() {
          component.goToEnd();
        }, 100);
      });
    },
    newMessage: function(message) {
      console.log(message);
      this.thread.messages.push(message);
      this.goToEnd();
    },

    fileAdded: function(file, response) {
      console.log({ file: file, response: response });

      let data = {
        thread: this.thread.id,
        attached: response.data.id,
        message: this.$t('File attached'),
      };
      console.log(data);
      ThreadAPI.postMessage(data).then(res => {
        console.log(res);
        this.newMessage(res.data.data);
      });
    },
    downloadEntity(mediaId) {
      console.log(mediaId);

      apiCtrl
        .get('/document/download/' + mediaId)
        .then(res => {
          apiCtrl.downloadFile(res.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    goToEnd() {
      console.log('scrollTarget', this.scrollTarget, 'scrollOptions', this.scrollOptions);
      this.$vuetify.goTo(this.scrollTarget, this.scrollOptions);
    },
    readLater(goBack = false) {
      ThreadAPI.changeThreadReadByCustomer(this.thread.id, 0).then(response => {
        this.thread = response.data.data;
        this.loading = false;
      });
      this.thread.read_by_customer = 0;
      if (goBack) {
        this.goBack();
      }
    },
    markAsRead() {
      ThreadAPI.changeThreadReadByCustomer(this.$route.params.thread, 1).then(response => {
        this.thread = response.data.data;
        this.loading = false;
      });
      this.thread.read_by_customer = 1;
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style>
.message-container img {
  max-width: 100% !important;
}
</style>
